class ArtGalleryMasonry extends HTMLElement {
  #resizeObserver;
  #layoutFrame;

  connectedCallback() {
    if (!this.classList.contains('art-gallery__grid--masonry')) return;

    this.#resizeObserver = new ResizeObserver(() => this.#scheduleLayout());
    this.#resizeObserver.observe(this);

    for (const image of this.querySelectorAll('img')) {
      if (!image.complete) image.addEventListener('load', this.#scheduleLayout, { once: true });
    }

    this.#scheduleLayout();
  }

  disconnectedCallback() {
    this.#resizeObserver?.disconnect();
    cancelAnimationFrame(this.#layoutFrame);
  }

  #scheduleLayout = () => {
    cancelAnimationFrame(this.#layoutFrame);
    this.#layoutFrame = requestAnimationFrame(() => this.#layout());
  };

  #layout() {
    const items = [...this.querySelectorAll('.art-gallery__item')];
    if (!items.length || !this.clientWidth) return;

    const configuredColumns = Number.parseInt(this.dataset.columns || '2', 10);
    const columns = window.innerWidth < 750 ? 1 : window.innerWidth < 990 ? 2 : configuredColumns;
    const gap = Number.parseInt(this.dataset.gap || '24', 10);
    const itemWidth = (this.clientWidth - gap * (columns - 1)) / columns;
    const columnHeights = Array(columns).fill(0);

    for (const item of items) {
      item.style.width = `${itemWidth}px`;

      const shortestColumn = columnHeights.indexOf(Math.min(...columnHeights));
      item.style.left = `${shortestColumn * (itemWidth + gap)}px`;
      item.style.top = `${columnHeights[shortestColumn]}px`;

      columnHeights[shortestColumn] += item.getBoundingClientRect().height + gap;
    }

    this.style.height = `${Math.max(...columnHeights) - gap}px`;
    this.dataset.ready = '';
  }
}

if (!customElements.get('art-gallery-masonry')) {
  customElements.define('art-gallery-masonry', ArtGalleryMasonry);
}
